import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import MovileurosSalesChart from './graphs/MovileurosSalesChart';
import '../../App.css';
import getMovileurosSales from '../../services/getMovileurosSales';

const Sales = (props) => {

  const t = props.t;
  const i18n = props.i18n;
  const [movileurosSales, setMovileurosSales] = useState([])

  useEffect(() => {
    getMovileurosSales(props.loginParameters.accesToken).then(movileurosSales => setMovileurosSales(movileurosSales))
  }, [props.loginParameters.accesToken])

  return (
    <Container id="main-container">
      <h2> Ventas de Movileuros</h2>
      <Tabs
        defaultActiveKey="daily"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="daily" title={t('daily')}>
          <MovileurosSalesChart
            data={movileurosSales.dataByDay}
            xlabel='date'
            t={t}
            i18n={i18n}
            type={'daily'}
          />
        </Tab>
        <Tab eventKey="weekly" title={t('weekly')}>
          <MovileurosSalesChart
            data={movileurosSales.dataByWeek}
            xlabel='week'
            t={t}
            i18n={i18n}
            type={'weekly'}
          />
        </Tab>
        <Tab eventKey="monthly" title={t('monthly')}>
          <MovileurosSalesChart
            data={movileurosSales.dataByMonth}
            xlabel='month'
            t={t}
            i18n={i18n}
            type={'monthly'}
          />
        </Tab>
      </Tabs>
    </Container>
  );
};

export default Sales;